import styled from "../../../styled/index";
export const ConnectionIndicatorCircle = styled("span") `
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  min-width: ${({ width }) => width || 10}px;
  min-height: ${({ width }) => width || 10}px;
  width: ${({ width }) => width || 10}px;
  height: ${({ width }) => width || 10}px;
  background: ${({ status, theme }) => status === "connected"
    ? theme.status_colors.complete
    : status === "connecting"
        ? theme.status_colors.unconfirmed
        : theme.status_colors.cancelled};
`;
//# sourceMappingURL=circle.js.map